export function parseSplitterSize(rawSplitterSize: unknown, defaultSize = [70, 30]): number[] {
  let splitterSizeArray = [...defaultSize];

  if (typeof rawSplitterSize === 'string') {
    const parsed = rawSplitterSize.split(',').map((s) => Number(s.trim()));
    if (parsed.length === 2 && !isNaN(parsed[0]) && !isNaN(parsed[1])) {
      splitterSizeArray = parsed;
    }
  } else if (Array.isArray(rawSplitterSize) && rawSplitterSize.length === 2) {
    splitterSizeArray = [Number(rawSplitterSize[0]), Number(rawSplitterSize[1])];
  }

  return splitterSizeArray;
}
